import React from "react"
import styles from "./header.module.scss"

const Header = () => (
  <header className={styles.header}>
    <div className={styles.headerContent}>
      <h1 className={styles.headerTitle}>Black in Design Conference</h1>
      <h2 className={styles.headerTitle}>Black Futurism 2019</h2>
      <h3 className={styles.headerTitle}>October 04 — 06</h3>
    </div>
    <div className={styles.headerContent}>
      <h1 className={styles.headerTitle}>Black in Design Conference</h1>
      <h2 className={styles.headerTitle}>Black Futurism 2019</h2>
      <h3 className={styles.headerTitle}>October 04 — 06</h3>
    </div>
  </header>
)

export default Header
